export const coreSchema = {
    type: 'object',
    properties: {
        host: { type: 'string' },
        port: { type: 'number' },
    },
};
